if (typeof WrappedCustom === 'undefined') {
    class WrappedCustom {
        static VARIANT_SELECTOR = '[feature="variant"] fieldset [data-variant-id] input[type="radio"]';

        static getWrappedElement = () => { 
            return document.querySelector('wrapped-extension') 
        }
    
        static getSelectedWrappedPricing = (wrapper) => {
            if (wrapper?.querySelector('wrapped-product-provider[is-checked="false"]')) {
               return null;
            }

            const selectedOption = wrapper?.querySelector(`${WrappedCustom.VARIANT_SELECTOR}:checked`);
            return selectedOption?.parentNode?.querySelector('[part="pricing"]')?.textContent || '';
        }
    
        static updateWrappedPreviewPricing = (wrapper) => {
            const variantOptions = wrapper?.querySelectorAll(WrappedCustom.VARIANT_SELECTOR);
            const wrappedPreviewPricing = wrapper?.querySelector('[feature="checkbox"] [part="container"] [part="pricing"]');

            if (variantOptions.length <= 1) {
                if (wrappedPreviewPricing && wrappedPreviewPricing.textContent) {
                    const currentPrice = wrappedPreviewPricing.textContent?.replace(/[()]/g, '');
                    wrappedPreviewPricing.textContent = `(${currentPrice})`;
                }
                return null;
            }

            const selectedWrappingPrice = WrappedCustom.getSelectedWrappedPricing(wrapper);
    
            if (wrappedPreviewPricing) {
                wrappedPreviewPricing.textContent = selectedWrappingPrice ? `(${selectedWrappingPrice})` : '';
            }
        }
    
        static handleProductLoaded = () => {
            let scriptExecuted = false;
  
            const observer = new MutationObserver((mutationsList) => {
                for (const mutation of mutationsList) {
                    if (mutation.type !== 'childList') {
                        continue;
                    }

                    mutation.addedNodes.forEach((node) => {
                        if (node.nodeType !== 1) {
                            return;
                        }

                        const element = node?.querySelector('wrapped-extension [feature="checkbox"] [part="container"] [part="pricing"]');

                        // Check if the re-appended node contains the target wrapper
                        if (element && !scriptExecuted) {
                            const target = WrappedCustom.getWrappedElement();
                            WrappedCustom.updateWrappedPreviewPricing(target);
                            scriptExecuted = true;
                            observer.disconnect();
                            return;
                        }
                    });
                }
            });
            
            observer.observe(document.body, { childList: true, subtree: true });
        }
    
        static handleWrappedEventProductPage = () => {
            const element = WrappedCustom.getWrappedElement();
            if (element) {
                WrappedCustom.updateWrappedPreviewPricing(element);
            }
        }
    }

    if (!window.wrappedEventProductPageListenerAdded) {
        window.wrappedEventProductPageListenerAdded = true;
        document.addEventListener(
            'wrapped:event:product-page', 
            WrappedCustom.handleWrappedEventProductPage
        );
    }

    WrappedCustom.handleProductLoaded();
  }